// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyA50-Dnh36mx1vorHs_s3FOq0cxWfT8kGo",
    authDomain: "abeld-reward.firebaseapp.com",
    projectId: "abeld-reward",
    storageBucket: "abeld-reward.appspot.com",
    messagingSenderId: "391446245585",
    appId: "1:391446245585:web:69294e1633240d117b55f0",
    measurementId: "G-9QCBGM8S5E"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
